/** Injected at build time by webpack DefinePlugin (see webpack.config.js). */
declare const __API_BASE_URL__: string;

/** Procxo API gateway base URL (no trailing slash). */
export const API_BASE_URL = __API_BASE_URL__;

/** Outlook add-in webpack dev server (HTTPS). */
export const ADDIN_DEV_PORT = 3009;

export const ADDIN_DEV_ORIGIN = `https://localhost:${ADDIN_DEV_PORT}`;

/** Production add-in UI origin (static hosting). */
export const ADDIN_PROD_ORIGIN = "https://outlookaddin.katdev.com";

/** Max task title length enforced by the API. */
export const TASK_TITLE_MAX_LENGTH = 200;
